module.exports = __webpack_public_path__ + "assets/img/kncb-partners-with-ludimos.80ab1f32.jpg";